import src from "IMAGE";
export default { src, width: 750, height: 224, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAIAAADq9gq6AAAAPUlEQVR42gEyAM3/AKjQ9qrR9qzS9q/T9rHU97PV97TV97bW9wC31ve52Pe82fi+2vjA2/jB2/jC3PjD3PnfjChIuQ7VEgAAAABJRU5ErkJggg=="};
